import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'material-ui/Select';
import Input from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import { ListItemText } from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';
import { MenuItem } from 'material-ui/Menu';
import Button from '../../components/Buttons';

class SelectSearch extends Component {
    static propTypes = {
        selectFields: PropTypes.array.isRequired,
        buttonText: PropTypes.string.isRequired,
        selectSearchHandler: PropTypes.func.isRequired,
        isResetSearch: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isResetSearch !== this.props.isResetSearch && this.props.isResetSearch){
            this.setState(this.getInitialState())
        }
    }

    getInitialState = () => {
        //generate state base on selectField's key
        return this.props.selectFields.reduce((prev, curr)=> {
            prev[curr.key] = curr.multiple ? [] : '';
            return prev
        }, {});
    }

    handleChange = (name, options) => event => {
        const value = event.target.value;
        this.setState({[name]: value});
    }

    renderOptions = (options, key) => {
        if (options) {
            return options.map( (o, i) => {
                return  <MenuItem
                            className="search__select--menuItem"
                            key={i}
                            value={o.value}>
                            <Checkbox
                                inputProps={{ tabIndex: 0 }}
                                className="search__select--menuItem--checkbox"
                                checked={this.state[key].includes(o.value)} />
                            <ListItemText
                                tabIndex="0"
                                aria-label={o.label.replace(/-/i, 'to')}
                                className="search__select--menuItem--text"
                                primary={o.label} />
                        </MenuItem>
            });
        }
    }

    renderSelectFields = () => {
        return this.props.selectFields.map( (f, i) => {
            return  <FormControl key={i} className="search__select--formControl">
                        <label
                            style={{ visibility : this.state[f.key].length === 0? 'visible' : 'hidden'}}
                            className="search__select--placeholder"
                            htmlFor={`search_select_${f.key}`}
                            aria-label={f.altLabel}>
                            {f.label}
                        </label>
                        <Select
                            tabIndex={0}
                            aria-label={f.altLabel}
                            disableUnderline
                            input={<Input inputProps={{ tabIndex: 0 }} id={`search_select_${f.key}`} />}
                            className="search__select--selectTag"
                            multiple={f.multiple}
                            renderValue={selected => selected.join(', ')}
                            value={this.state[f.key]}
                            onChange={this.handleChange(f.key, f.options)}>
                            {this.renderOptions(f.options, f.key)}
                        </Select>
                    </FormControl>
        });
    }

    render () {
        return (
            <div className="search__select">
                {this.renderSelectFields()}
                <FormControl className="search__select--button">
                    <Button
                        color="secondary"
                        onClick={() => this.props.selectSearchHandler(this.state)}
                        variant="raised">
                        {this.props.buttonText}
                    </Button>
                </FormControl>
            </div>
        );
    }
}

export default SelectSearch;
